import { __generator } from "tslib";
import { all, takeEvery, select } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { flagEnabled } from '../flags';
import { registerServiceWorker } from './actions';
function handleServiceWorkerRegistration() {
    var allowProgressiveWebApp, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(flagEnabled, 'llama_game')];
            case 1:
                allowProgressiveWebApp = _a.sent();
                if (!allowProgressiveWebApp) {
                    return [2 /*return*/];
                }
                if (!(typeof navigator !== 'undefined' && 'serviceWorker' in navigator)) return [3 /*break*/, 5];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, navigator.serviceWorker.register('/sw.js', {
                        scope: '/',
                    })];
            case 3:
                _a.sent();
                return [3 /*break*/, 5];
            case 4:
                err_1 = _a.sent();
                // Failed registration, service worker won't be installed
                ddt.log('pwa', 'Whoops. Service worker registration failed, error:', err_1);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(registerServiceWorker, handleServiceWorkerRegistration),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map